package com.essntl.features.paymentparameter.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [PaymentParameterSupabaseDataSource::class])
internal class PaymentParameterSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<PaymentParameterDto> {
    override val tableName: String = "payment_parameter"
}
